import { Tag } from 'primereact/tag';

export default function CTag(props) {
    return <Tag className="mr-1 inter" value={props.id}></Tag>;
}
